import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import stepByStepValidate from '@/services/_helpers/stepByStepValidate';
export default Vue.extend({
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    name: 'widthdrawConfirmWalletSecretYubikeyPopupChunk',
    data: () => ({
        step: 1,
        hasWhiteListSecret: true,
        whitelistAddressIsLoading: false,
        userWalletAddress: null,
        form: {
            fields: {
                secretCode: {
                    valid: false,
                    value: '',
                    type: 'password',
                    rules: [
                        (v) => Boolean(v.length) || 'Поле обязательно'
                    ],
                    isLoading: false,
                    exist: false,
                    responseErrors: []
                }
            }
        }
    }),
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), { getUserWalletAddress() {
            if (this.userWalletAddress)
                return this.userWalletAddress;
            if (this.slotData.summaryWithdrawData.walletData.address)
                return this.slotData.summaryWithdrawData.walletData.address;
            return this.slotData.summaryWithdrawData.walletData.blurredAddress;
        } }),
    watch: {
        'form.fields.secretCode.value'() {
            this.$store.commit('popupModule/setSlotData', { responseErrors: [] });
        }
    },
    created() {
        this.checkWhitelistSecret();
    },
    methods: {
        checkWhitelistSecret() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield this.services.mainService.checkWhitelistSecret(null);
                this.hasWhiteListSecret = response.data.walletSecret;
            });
        },
        toggleSecretAppear() {
            const vm = this;
            vm.form.fields.secretCode.type = vm.form.fields.secretCode.type === 'password' ? 'text' : 'password';
        },
        validateFirstStep() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.secretCode.responseErrors = [];
                vm.form.fields.secretCode.isLoading = true;
                setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    const response = yield stepByStepValidate({
                        name: vm.slotData.name,
                        endpointName: vm.slotData.endpointName,
                        data: {
                            sessionId: vm.slotData.sessionId,
                            payload: { wallet_secret: vm.form.fields.secretCode.value }
                        },
                        steps: vm.slotData.steps
                    });
                    vm.form.fields.secretCode.isLoading = false;
                    if (response.success) {
                        this.form.fields.secretCode.exist = true;
                        vm.whitelistAddressIsLoading = true;
                        const currentWalletWithAddressResponse = yield vm.services.mainService.getWhitelistWalletsWithAddresses({
                            walletSecret: vm.form.fields.secretCode.value
                        }, vm.slotData.summaryWithdrawData.walletData.id);
                        if (currentWalletWithAddressResponse.success && ((_b = (_a = currentWalletWithAddressResponse.data) === null || _a === void 0 ? void 0 : _a.wallets[0]) === null || _b === void 0 ? void 0 : _b.address)) {
                            vm.userWalletAddress = currentWalletWithAddressResponse.data.wallets[0].address;
                        }
                        vm.whitelistAddressIsLoading = false;
                    }
                    else {
                        vm.form.fields.secretCode.responseErrors = response.errors;
                    }
                }), 1000);
            });
        },
        validateFirstStepWithoutSecret() {
            this.$emit('onSubmit');
        }
    }
});
